import { gql } from '@apollo/client';
import { FileType } from '@jbc-year-end-adj/2024/types';

export type QueryResult = {
  request: Request;
  clientSetting: ClientSetting;
};

type ClientSetting = {
  id: string;
  requestImageUploadSettings: requestImageUploadSettings;
};

type requestImageUploadSettings = {
  housingLoan: 'none' | 'optional' | 'required';
};

export type Request = {
  id: string;
  profile: {
    id: string;
    housingLoan: HousingLoan;
  };
};

export type HousingLoan = {
  id: string;
  housingLoanDeductionApplicableCount: string;
  housingLoanDeductionApplicableAmount: string;
  image?: FileType;
  certificateImage?: FileType;
  housingLoanDetails: HousingLoanDetail[];
};

export type HousingLoanDetail = {
  id: string;
  no: number;
  deductionClassification: DeductionClassification;
  residenceStartOn: string;
  yearEndBalance: string;
  specialDeduction: SpecialDeduction;
};

export type DeductionClassification =
  | 'normal'
  | 'eritified'
  | 'extension'
  | 'earthquake'
  | 'pecial_case_house_normal'
  | 'pecial_case_house_certified'
  | 'pecial_case_house_earthquake';

export type SpecialDeduction = 'none' | 'applied' | 'special_applied' | 'special_exception_applied';

export const HOUSING_LOAN_FRAGMENT = gql`
  fragment HousingLoan on Profile {
    housingLoan {
      id
      housingLoanDeductionApplicableCount
      housingLoanDeductionApplicableAmount
      image {
        url
        filename
      }
      certificateImage {
        url
        filename
      }
      housingLoanDetails {
        id
        no
        deductionClassification
        residenceStartOn
        yearEndBalance
        specialDeduction
      }
    }
  }
`;

export const FETCH_HOUSING_LOAN = gql`
  query housingLoan {
    clientSetting {
      id
      requestImageUploadSettings {
        housingLoan
      }
    }
    request {
      id
      profile {
        id
        ...HousingLoan
      }
    }
  }
  ${HOUSING_LOAN_FRAGMENT}
`;
